class ScrollablePanel extends HTMLElement {
  constructor() {
    super();
    this.panel = this.closest('[data-panel]');
  }
  connectedCallback() {
    const resizeObserver = new ResizeObserver(this.onResize.bind(this));
    resizeObserver.observe(this);
    this.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    if (!this.panel) {
      return;
    }

    if (this.scrollTop > 0) {
      this.panel.classList.add('scrolling');
      this.style.borderTop = '1px solid #e5e5e5';
    } else {
      this.panel.classList.remove('scrolling');
      this.style.borderTop = 'none';
    }
  }

  onResize() {
    this.style.setProperty('--scrollbar-width', this.offsetWidth - this.clientWidth + 'px');
  }
}

customElements.define('scrollable-panel', ScrollablePanel);
